var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"name":_vm.name,"id":_vm.id,"title":_vm.title},on:{"filterButtonClicked":_vm.clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }